/**
  * Adds JSInterop functions for the Blazor library to call for Session Storage operations.
  */
export default class SessionStorageHelper {
  /**
   * Sets the item in session storage.
   * @param {any} key The key.
   * @param {any} value The value.
   */
  setItem(key: any, value: any): void {
    sessionStorage.setItem(key, value);
  }

  /**
   * Gets the item from session storage.
   * @param {any} key The key.
   * @returns {any} The item.
   */
  getItem(key: any): any {
    return sessionStorage.getItem(key);
  }

  /**
   * Removes the item from session storage.
   * @param {any} key The key.
   */
  removeItem(key: any): void {
    sessionStorage.removeItem(key);
  }

  /**
   * Clears the session storage.
   */
  clear(): void {
    sessionStorage.clear();
  }
}